
import React from "react"

import './FacebookCommentsSection.scss'

const FacebookCommentsSection = ({question, url=null}) => {
  
  let brkURL = typeof window !== 'undefined' ? window.location.href : '';
  if (url) {
    brkURL = url
  }

  return (
    <div className={`facebook-comments-container`}>
       <div className={`main`}>
        {question && <h2>{question}</h2>}
        <div className={"fb-comments"} data-href={brkURL}  data-width="100%"></div>
      </div>
    </div>
  )
}

export default FacebookCommentsSection
